import React, {PureComponent} from "react"
import {Row, Col} from "react-bootstrap"
import moment from "moment"

import {Card} from "@irati/types"
import {FormattedMessage, InjectIntl} from "@irati/utils/lang"
import {H6} from "@irati/ui/src/Typography"
import Flex from "@irati/ui/src/Flex"
import Button from "@irati/ui/src/Button"

interface Props extends InjectIntl {
  card: Card,
  lastFour: string,
  expMonth: number,
  expYear: number,
  onClick: (card: Card) => void
}

class UserLinkedCard extends PureComponent<Props> {
  render() {
    const {card, lastFour, expMonth, expYear, onClick} = this.props
    return (
      <Row>
        <Col xs={6}><H6>**** **** **** {lastFour}</H6></Col>
        <Col xs={3}>
          <Flex justifyContent="flex-end">
            <H6>{moment(new Date(expYear, expMonth - 1, 1)).format("MM/YY")}</H6>
          </Flex>
        </Col>
        <Col xs={3}>
          <Flex justifyContent="flex-end" onClick={() => onClick(card)}>
            <Button destructive><FormattedMessage id="account.linkedCards.remove" /></Button>
          </Flex>
        </Col>
      </Row>
    )
  }
}

export default UserLinkedCard
